export default __webpack_public_path__ + "static/media/Clínica-Gravataí.488e1052.png";